import React from 'react'
import {
  Switch,
  Route,
  BrowserRouter
} from 'react-router-dom'
import ErrorPage from '@mymoons/error-page'
import Appointment from './Components/Appointment/Appointment'

/**
 * Main app
 * @returns {void} .
 */
const App = () => (
  <BrowserRouter>
    <Switch>
      <Route
        path="/appointment-success/:publicKey"
        component={() => (
          <Appointment />
        )}
      />
      <Route
        path="/:publicKey"
        component={() => (
          <Appointment />
        )}
      />
      <Route
        component={() => (<ErrorPage />)}
      />
    </Switch>
  </BrowserRouter>
)

export default App
